import Vue from "vue";
import moment from "moment";
import { VUE_APP_DECIMALS } from "@/config";

function currency(value, countryCode) {
	if (!value) {
		value = 0;
	}

	const currency = {
		BR: { locale: "pt-BR", currency: "BRL" },
		US: { locale: "en-US", currency: "USD" },
		CO: { locale: "es-CO", currency: "COP" },
		EC: { locale: "en-US", currency: "USD" },
	};

	let currentCurrency =
		countryCode && currency[countryCode]
			? currency[countryCode]
			: currency["US"];

	if (VUE_APP_DECIMALS === 0) {
		value = Math.trunc(value);
	}

	const string = (value * 1).toLocaleString(currentCurrency.locale, {
		style: "currency",
		currency: currentCurrency.currency,
		minimumFractionDigits: VUE_APP_DECIMALS,
	});

	if (countryCode == "UY") {
		const arrCurrency = string.split("$");

		return `$USD ${arrCurrency[1]}`;
	}

	return string;
}

function currencyUSA(value, precision) {
	if (!value) {
		value = 0;
	}
	var options = {
		style: "currency",
		currency: "USD",
	};
	if (typeof precision === "number") {
		options.minimumFractionDigits = precision;
		options.maximumFractionDigits = precision;
	}
	if (typeof value === "string") {
		value = parseFloat(value);
	}

	return value.toLocaleString("en-US", options);
}

function dateToBRNoHour(value) {
	if (value == "0000-00-00" || !value) {
		return "";
	}
	return value.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
}

function dateToUSNoHour(value) {
	if (value == "0000-00-00" || !value) {
		return "";
	}
	value = value.split(" ").shift();
	return moment(value).format("MM/DD/YYYY").toUpperCase();
}

function documentPersonBr(documentId) {
	if (!documentId) {
		return "";
	}
	documentId =
		typeof documentId != "string" ? documentId.toString() : documentId;
	if (documentId.length > 11) {
		documentId = documentId.padStart(14, "0");
		documentId = documentId.replace(
			/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
			"$1.$2.$3/$4-$5"
		);
	} else {
		documentId = documentId.padStart(11, "0");
		documentId = documentId.replace(
			/^(\d{3})(\d{3})(\d{3})(\d{2})/,
			"$1.$2.$3-$4"
		);
	}
	return documentId;
}

function upperCase(value) {
	return value.toString().toUpperCase();
}

function formatDateValue(value) {
	if (value.indexOf("-")) {
		let valueInput = value.split("-");
		if (
			valueInput.length >= 3 &&
			!isNaN(valueInput[0]) &&
			!isNaN(valueInput[1])
		) {
			let data = new Date(value);
			let dataFormatada = `${addZero(data.getDate())}/${addZero(
				data.getMonth() + 1
			)}/${data.getFullYear()}`;
			return dataFormatada;
		} else {
			return value;
		}
	}
}
function addZero(numero) {
	if (numero <= 9) return "0" + numero;
	else return numero;
}

Vue.filter("currency", currency);
Vue.filter("currencyUSA", currencyUSA);
Vue.filter("dateToUSNoHour", dateToUSNoHour);
Vue.filter("dateToBRNoHour", dateToBRNoHour);
Vue.filter("documentPersonBr", documentPersonBr);
Vue.filter("upperCase", upperCase);
Vue.filter("formatDateValue", formatDateValue);
Vue.filter("addZero", addZero);

export {
	currency,
	currencyUSA,
	dateToBRNoHour,
	dateToUSNoHour,
	documentPersonBr,
	upperCase,
	formatDateValue,
	addZero,
};
